import React from "react";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";

const SeasonForm = ({ initialData, onSuccess, onError }) => {
  return (
    <MasterDataFormV2
      title="Season"
      apiUrl="/season"
      initialData={initialData}
      fields={[
        {
          name: "name",
          label: "Season Name",
          type: "text",
          required: true,
          maxLength: 255,
        },
        {
          name: "start_date",
          label: "Start Date",
          type: "date",
          required: true,
        },
        {
          name: "end_date",
          label: "End Date",
          type: "date",
        },
        // is_active
        {
          name: "is_active",
          label: "Is Active",
          type: "checkbox",
        },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default SeasonForm;
